import React, { useMemo, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import DropDownButton from 'devextreme-react/drop-down-button';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/AuthContext';
import './UserPanel.scss';
import type { UserPanelProps } from '../../types';

export default function UserPanel({ menuMode }: UserPanelProps) {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();
  const savedUser = JSON.parse(localStorage.getItem("user") as string);

  const navigateToProfile = useCallback(() => {
    navigate("/profile");
  }, [navigate]);

  const handleLogout = () => {
    logoutUser();
    navigate("/login");
  };

  const menuItems = useMemo(() => ([
    {
      text: savedUser.data.id,
      icon: 'user',
      // onClick: navigateToProfile
    },
    {
      text: 'Logout',
      icon: 'panelleft',
      onClick: handleLogout
    }
  ]), [navigateToProfile, handleLogout]);

  const dropDownButtonAttributes = {
    class: 'user-button'
  };

  const buttonDropDownOptions = {
    width: '150px'
  };

  return (
    <div className='user-panel'>
      {menuMode === 'context' && (
        <DropDownButton
          stylingMode='text'
          icon='https://mylittlefairies.online/avatars/9.png'
          showArrowIcon={false}
          elementAttr={dropDownButtonAttributes}
          dropDownOptions={buttonDropDownOptions}
          items={menuItems}>
        </DropDownButton>
      )}
      {menuMode === 'list' && (
        <List items={menuItems} />
      )}
    </div>
  );
}
